import * as React from "react";
const SvgFiRrMugTeaSaucer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21 21a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h19a1 1 0 0 1 1 1m3-12.5v2c0 1.93-1.57 3.5-3.5 3.5h-1.601A5.01 5.01 0 0 1 14 18H7c-2.757 0-5-2.243-5-5V5c0-1.654 1.346-3 3-3h11c1.654 0 3 1.346 3 3h1.5C22.43 5 24 6.57 24 8.5M8.293 8.121A1 1 0 0 0 8 8.828V10.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V8.828c0-.263-.107-.521-.293-.707L9 7.414zM17 5c0-.552-.449-1-1-1h-6v1.586l1.121 1.121c.567.566.879 1.32.879 2.121V10.5c0 1.379-1.122 2.5-2.5 2.5h-1A2.503 2.503 0 0 1 6 10.5V8.828c0-.801.312-1.555.879-2.121L8 5.586V4H5c-.551 0-1 .448-1 1v8c0 1.654 1.346 3 3 3h7c1.654 0 3-1.346 3-3zm5 3.5c0-.827-.673-1.5-1.5-1.5H19v5h1.5c.827 0 1.5-.673 1.5-1.5z"
    />
  </svg>
);
export default SvgFiRrMugTeaSaucer;
